"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserHistory = void 0;
const history_1 = require("history");
exports.browserHistory = history_1.createBrowserHistory();
//# sourceMappingURL=History.js.map